import { render, staticRenderFns } from "./IconSet.vue?vue&type=template&id=2d21fd34&scoped=true"
import script from "./IconSet.vue?vue&type=script&lang=js"
export * from "./IconSet.vue?vue&type=script&lang=js"
import style0 from "./IconSet.vue?vue&type=style&index=0&id=2d21fd34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d21fd34",
  null
  
)

export default component.exports